// Use This URL for testing
const URL = "bipl.bfiinfotech.co.in";

export const BASE_URL = `https://${URL}/api/`;
export const DOMAIN = `https://${URL}`;
export const MAX_COLS = 30;
export const ID_BASE = 1;
export const SRF_ID_BASE = 1;
export const MAX_SIZE_MB = 3;

// TODO: need to move to DB
export const BANK_DETAILS = {
  "Bank Name": "State Bank OF India, CBD Belapur Navi Mumbai",
  "Bank A/c. No.": "39813124209",
  "IFSC Code": "SBIN0061520",
};

export const weightUncertaintySupportiveValues ={
  barometer: 0.92,
  tempIndicator:0.4,
  rhIndicator: 1.6,
  weightBox:7950,
};

export const G_Value =  9.79139;

export const GST_NUMBER = "27DSVPK5381Q1ZH";

export const DISABLED_MODULE =["Courier Register","History Card","Expenses","Client Complaints","Client Feedback","Purchase","CoordinatesAddress","Discipline","Datasheet Template","Settings","WCR Report","Training Resources","Inward Register","External Calibration","Audit","emailOtpVerification","reservedSrf","DatasheetReadingsAudit","locationTracking","UULIMS","Independent Due","Task Management","Independent SRF","Inward Pending Items","Thread Ring/Plug","Tapper Thread Ring","Plain Plug/ Snap Gauge"]; 

export const DEVICE_TYPE = ["desktop", "tablet", "mobile"];

export const LATEST_HASH = "89e09b5893d3f6da022ade0dbd903a52d47c63c6";

export const DEFAULT_MAX_PRECISION = 10;

export const TIME_ZONE_OFFSET = "";
// - INTERVAL 3 HOUR - INTERVAL 30 MINUTE

export const UnicodeCompany = "BCL";
